import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertTriangle, Plus } from 'lucide-react';
import { AuroraBackdrop } from '../AuroraBackdrop';
import { SupabaseSetupNotice } from '../SupabaseSetupNotice';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { StudentDetailModal } from '../students/StudentDetailModal';
import { StudentFormModal } from '../students/StudentFormModal';
import { StudentsProvider, useStudents } from '../../contexts/StudentsContext';
function ShellBody() {
  const {
    students,
    error,
    setupRequired,
    openCreateForm
  } = useStudents();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  return <div className="min-h-screen w-full" data-id="element-150" data-mp="371e4c5jn8tg3">
      <AuroraBackdrop data-id="element-151" data-mp="372fr37a0v4dn" />

      <Sidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed(value => !value)} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} totalStudents={students.length} data-id="element-152" data-mp="3737c5o5ztjpo" />

      <Topbar onOpenMobileNav={() => setMobileOpen(true)} sidebarCollapsed={collapsed} data-id="element-153" data-mp="1kfz3snydganc" />

      <main className={`px-4 pb-28 pt-6 transition-[margin] duration-300 sm:px-6 lg:pb-12 ${collapsed ? 'lg:ml-[84px]' : 'lg:ml-[264px]'}`} data-id="element-154" data-mp="1fgm9xj9323b9">
        {setupRequired ? <div className="mx-auto mb-6 w-full max-w-3xl" data-id="element-155" data-mp="28507xz068zmt">
            <SupabaseSetupNotice data-id="element-156" data-mp="284idn7x2kvhj" />
          </div> : error && <div role="alert" className="mb-5 flex items-start gap-3 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-4" data-id="element-157" data-mp="236qb7jystqz3">
              <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" data-id="element-158" data-mp="1t8sm6u947q5f" />
              <div className="min-w-0 text-sm" data-id="element-159" data-mp="mrp4igpz00zx">
                <p className="font-semibold text-foreground" data-id="element-160" data-mp="mti97qh0wb5a">Supabase could not return your records</p>
                <p className="mt-0.5 break-words text-muted-foreground" data-id="element-161" data-mp="hrj52edgla7a">{error}</p>
              </div>
            </div>}

        <Outlet data-id="element-162" data-mp="3a04lfug493zj" />
      </main>

      {/* Floating quick action */}
      <motion.button type="button" onClick={openCreateForm} initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1,
      y: [0, -6, 0]
    }} transition={{
      opacity: {
        duration: 0.3
      },
      scale: {
        duration: 0.3
      },
      y: {
        duration: 4.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} whileHover={{
      scale: 1.06
    }} whileTap={{
      scale: 0.96
    }} aria-label="Add student" className="fixed bottom-6 right-5 z-30 inline-flex h-14 items-center gap-2 rounded-2xl brand-gradient px-5 text-sm font-semibold text-white shadow-2xl shadow-indigo-500/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:bottom-8 sm:right-8" data-id="element-163" data-mp="39zlbp10mdlwl">
        <Plus className="h-5 w-5" data-id="element-164" data-mp="28cvfny6c4pik" />
        <span className="hidden sm:inline" data-id="element-165" data-mp="1oopisast580c">Add Student</span>
      </motion.button>

      <StudentFormModal data-id="element-166" data-mp="1knx7zd4aev1y" />
      <StudentDetailModal data-id="element-167" data-mp="1kofagrhjm5ib" />
    </div>;
}
export function DashboardShell() {
  return <StudentsProvider data-id="element-168" data-mp="1ynots011pfqi">
      <ShellBody data-id="element-169" data-mp="1yo7z8h9iebnn" />
    </StudentsProvider>;
}